import { useFilterDate } from "@/common/hooks/useFilterDate";
import { useMemo } from "react";
import { DashboardFilters } from "../../types/dashboards/dashboard.type";
import { DashboardComponentDateFilters, DashboardComponentFilterDefinitions, DashboardComponentFiltersParamsParsed, DashboardComponentFiltersProp } from "../../types/dashboards/dashboardComponent.type";

interface UseDashboardComponentParsedFiltersProps {
  filters: DashboardComponentFiltersProp;
  dashboardDesiredFilters: DashboardFilters[];
  definitionFilters: DashboardComponentFilterDefinitions;
  ignoreDashboardDesiredFilters?: boolean;
}

const useDashboardComponentParsedFilters = ({
  filters,
  dashboardDesiredFilters,
  definitionFilters,
  ignoreDashboardDesiredFilters,
}: UseDashboardComponentParsedFiltersProps) => {
  const { formattedDate } = useFilterDate(filters);

  return useMemo(() => {
    const _transformedFilters: DashboardComponentFiltersParamsParsed = {};

    for (const filterKey of Object.values(DashboardFilters)) {
      if (dashboardDesiredFilters.includes(filterKey) || ignoreDashboardDesiredFilters) {
        if (filterKey === DashboardFilters.DateRange) {
          if (DashboardComponentDateFilters.StartDate in definitionFilters) {
            _transformedFilters[DashboardComponentDateFilters.StartDate] = formattedDate.from;
          }

          if (DashboardComponentDateFilters.EndDate in definitionFilters) {
            _transformedFilters[DashboardComponentDateFilters.EndDate] = formattedDate.to;
          }

          continue;
        }

        if (filterKey in definitionFilters) {
          if (filters[filterKey]?.value) {
            _transformedFilters[filterKey] = filters[filterKey]?.value;
          } else {
            _transformedFilters[filterKey] = filters[filterKey];
          }
        }
      }
    }

    return _transformedFilters;
  }, [
    dashboardDesiredFilters.join(','),
    formattedDate.from,
    formattedDate.to,
    JSON.stringify(filters, (key, val) => key === 'date' ? undefined : val),
  ]);
}

export default useDashboardComponentParsedFilters;
